// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateform9(){
  var stuwdruk = $('.acf-field').find("[data-name='form9_stuwdruk']").find(':input').val();
  var gewicht = $('.acf-field').find("[data-name='form9_gewicht']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form9_zone']").find('label.selected > input[type="radio"]').val();
  var ankers_hoh = $('.acf-field').find("[data-name='form9_anker_hoh']").find(':input').val();
  var hoogte_element = $('.acf-field').find("[data-name='form9_hoogte']").find(':input').val();
  var houtkwaliteit = $('.acf-field').find("[data-name='form9_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var afstand_a = $('.acf-field').find("[data-name='form9_afstand_a']").find(':input').val();
  var afstand_b = $('.acf-field').find("[data-name='form9_afstand_b']").find(':input').val();
  var lengte_anker = $('.acf-field').find("[data-name='form9_lengte']").find(':input').val();
  var breedte_anker = $('.acf-field').find("[data-name='form9_breedte']").find(':input').val();
  var dikte = $('.acf-field').find("[data-name='form9_dikte']").find(':input').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form9Calculate',
      stuwdruk: stuwdruk,
      gewicht: gewicht,
      zone: zone,
      ankers_hoh: ankers_hoh,
      hoogte_element: hoogte_element,
      houtkwaliteit: houtkwaliteit,
      afstand_a: afstand_a,
      afstand_b: afstand_b,
      lengte_anker: lengte_anker,
      breedte_anker: breedte_anker,
      dikte: dikte
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form9Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });
}

$(document).ready(function(){
  $('#form9Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form9Calc .acf-form-submit').append('<input type="submit" id="calculate_form9" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form9').click(function(e){
    e.preventDefault();
    calculateform9();
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/form9.js